import PartnersTeamMembersTable from './PartnersTeamMembersTable'

type PartnersTeamPageProps = {
  partnerId: string
}

export default (props: PartnersTeamPageProps) => {
  return (
    <PartnersTeamMembersTable partnerId={props.partnerId} />
  )
}
